import React, { Fragment, useContext, useEffect, useState } from "react";

// Provider
import {
  AppContext,
  SET_PAGE_STATE,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";

// Utils

// UI
import { AlertLayer } from "../../../components/UI/Dialog";
import { Container, openLayerFn } from "../../Layout";

import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import XXX from "../../../resources/images/sub/device_link_guide_f62e.png";
import { putBodyData } from "./Main";

export default props => {
  const { userinfo, cfg, phonecfg, deviceCfg, pageState, dispatch } =
    useContext(AppContext);

  const [isConnected, setIsConnected] = useState(
    deviceCfg.deviceTypes[2].devices[0].isConnected
  );
  const [isConnecting, setIsConnecting] = useState(false);

  const settingState = (param1, param2) => {
    // setIsConnected(param1);
    setIsConnecting(param2);
    socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {};
  // 다이얼로그 ]]

  // 단말기 연동 api 호출
  const handleConnect = e => {
    try {
      settingState(false, true);
      socketManager(SocketCommand.F62E_B_REGISTER, settingState);
    } catch (e) {
      console.log("###e: ", e);
      handleDialog("", "기기연결은 단말기에서만 동작됩니다.");
      return;
    }
  };

  // 단말기 연동 api 호출
  const handleDisConnect = e => {
    try {
      console.log("phonecfg.phoneOS=====", phonecfg.phoneOS);
      settingState(false, true);
      socketManager(SocketCommand.F62E_B_REMOVE, settingState);
    } catch (e) {
      handleDialog("", "기기연결해제는 단말기에서만 동작됩니다.");
      return;
    }
  };

  // 단말기 연동 api 호출
  const handleMeasure = e => {
    try {
      if (phonecfg.phoneOS === "ANDROID") {
        window.java.measureDevice(0, "F62E-B");
      } else {
        webkit.messageHandlers.removeDevice.postMessage("0:F62E-B");
      }
    } catch (e) {
      handleDialog("", "단말기에서만 동작됩니다.");
      return;
    }
  };

  useEffect(() => {
    userHabit(phonecfg, "ST113");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  useEffect(() => {
    if (pageState.reload === 1) {
      dispatch({
        type: SET_PAGE_STATE,
        data: {
          type: "reload",
          state: 0,
        },
      });

      // 연결해제 후 위조건의 isConnected의 상태는 항상 false로 LOOP현상
      if (isConnecting) {
        socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
      }
    }

    setIsConnected(
      deviceCfg.deviceTypes[2].devices[0].isConnected
    );
  }, [pageState.reload]);

  useEffect(() => {
    setIsConnecting(false);
  }, [deviceCfg.deviceTypes[2].devices[0].isConnected]);

  return (
    <Fragment>
      <Container
        Title={"기기연결(체중계)"}
        dark={"dark"}
        isMain={false}
        goToUrl={"/mp/settings/accessory"}>
        <div className="contents">
          <div className="sub-contents">
            <div className="linkguide-contain">
              <div className="roundbox-list">
                <div>체중계에 올라 서서 체중계의 전원을 켜주세요.</div>
                <div>전원이 켜지면 앱 하단의 "연결" 버튼을 눌러주세요.</div>
                <div>연결이 완료되면 체중을 측정해 주세요.</div>
              </div>
              <div className="guide-img">
                <img src={XXX} alt="" />
              </div>
              {/* <div className="under-text">
                                배터리가 없는 경우 배터리를 삽입하면 자동으로 전원이 켜집니다.<br/>
                                실패할 경우 다시 시도하세요.
                            </div> */}
            </div>
          </div>
        </div>

        <div className="fix-area">
          <div className="under-fix-btnarea">
            {isConnected === false ? (
              isConnecting === false ? (
                <a
                  href={void 0}
                  className="btn-connect"
                  onClick={e => handleConnect(e)}>
                  <i></i>연결
                </a>
              ) : (
                <a href={void 0} className="btn-connect-ing">
                  <i></i>연결중
                </a>
              )
            ) : (
              <a
                href={void 0}
                className="btn-unconnect"
                onClick={e => handleDisConnect(e)}>
                <i></i>연결 해제
              </a>
            )}
          </div>
        </div>
        {/* 테스트 코드 start */}
        {/* 
                <div className="fix-area">
                    <div className="under-fix-btnarea">
                        {
                            ( isConnected === true )
                                ? <a href={void 0} className="btn-unconnect" onClick={(e) => handleMeasure(e)}><i></i>측정</a>
                                : null
                        }
                    </div>
                </div>
*/}
        {/* 테스트 코드 end */}
      </Container>

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />
    </Fragment>
  );
};

// 단말기 연동 api 호출
/*
 *   device: 0:혈압
 */
export const handleMeasure = (phonecfg, device, deviceName, handleDialog) => {
  try {
    console.log("phonecfg.phoneOS====" + phonecfg.phoneOS);
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.measureDevice(device, deviceName);
    } else {
      webkit.messageHandlers.removeDevice.postMessage(
        device.toString() + ":" + deviceName
      );
    }
  } catch (e) {
    handleDialog("", "단말기에서만 동작됩니다.");
    return;
  }
};
